import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const reportDateFilter = ({
  expensesContext,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => ({
  type: FilterType.Date,
  categories: [
    {
      kind: 'DateTimePicker',
      operation: 'between',
    },
  ],
  onUpdateValue: () => {
    trackFilters('report_date', expensesContext)
  },
  identifier: 'expensesList.reportDateFilter',
  path: 'reviewRequestAt',
  title: i18n.t('expenses_v2.list.header.review_request_at'),
})

export default reportDateFilter
